import { connect } from 'react-redux';

import ReportWithData from './ReportWithData.js';

const isActive = a => a.active === true;

const mapStateToProps = state => {
  const activeServer = state.servers.servers.find(isActive);
  return {
    viewportData: state.viewports.viewportSpecificData,
    context: state.ui.heatmapContext,
    server: activeServer,
  };
};

const ConnectedReport = connect(
  mapStateToProps,
  null
)(ReportWithData);

export default ConnectedReport;
